import { useQuery } from "@tanstack/react-query";
import React from "react";
import AddWhitelistEmails from "./AddWhitelistEmails";
import { Card, CardHeader } from "../ui/card"

export default function AdminPage() {
    return (
    <div className="max-w-[600px] mx-auto gap-4 flex flex-col">
        <Card>
            <CardHeader>
                <div className="text-xl font-semibold">
                    Admin Panel
                </div>
            </CardHeader>
        </Card>
        <AddWhitelistEmails />
    </div>)
}